import {
  ASSOCIATE_CHANGE,
  DEFAULT_LANGUAGE_CHANGE,
  LANGUAGE_TOGGLE,
  LANGUAGES_REQUEST_ASYNC,
  SAVE_LANGUAGE_FROM_TAGS_TOGGLE,
  SET_TAGS_AND_SEGMENTS_PAGE,
  SET_TAGS_AND_SEGMENTS_SEARCH,
  TAGS_AND_SEGMENTS_REQUEST_ASYNC,
  UPDATE_LANGUAGES_ASYNC,
} from './constants'

const getLanguages = () => ({ type: LANGUAGES_REQUEST_ASYNC.INITIATE })
const getLanguagesCancel = () => ({ type: LANGUAGES_REQUEST_ASYNC.CANCEL })
export const getLanguagesSuccess = (data) => ({
  type: LANGUAGES_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getLanguagesError = (error) => ({
  type: LANGUAGES_REQUEST_ASYNC.ERROR,
  error,
})

const updateLanguages = () => ({ type: UPDATE_LANGUAGES_ASYNC.INITIATE })
const updateLanguagesCancel = () => ({ type: UPDATE_LANGUAGES_ASYNC.CANCEL })
export const updateLanguagesSuccess = () => ({
  type: UPDATE_LANGUAGES_ASYNC.SUCCESS,
})
export const updateLanguagesError = (error) => ({
  type: UPDATE_LANGUAGES_ASYNC.ERROR,
  error,
})

const fetchTagsAndSegments = () => ({ type: TAGS_AND_SEGMENTS_REQUEST_ASYNC.INITIATE })
const fetchTagsAndSegmentsCancel = () => ({ type: TAGS_AND_SEGMENTS_REQUEST_ASYNC.CANCEL })
export const fetchTagsAndSegmentsSuccess = (data) => ({
  type: TAGS_AND_SEGMENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTagsAndSegmentsError = (error) => ({
  type: TAGS_AND_SEGMENTS_REQUEST_ASYNC.ERROR,
  error,
})

const setTagsAndSegmentsPage = (page) => ({
  type: SET_TAGS_AND_SEGMENTS_PAGE,
  payload: { page },
})
const setTagsAndSegmentsSearch = (search) => ({
  type: SET_TAGS_AND_SEGMENTS_SEARCH,
  payload: { search },
})

const changeDefaultLanguage = (id) => ({
  type: DEFAULT_LANGUAGE_CHANGE,
  payload: { id },
})
const toggleLanguage = (id, associatedId) => ({
  type: LANGUAGE_TOGGLE,
  payload: { id, associatedId },
})
const changeAssociate = (langId, id, initId) => ({
  type: ASSOCIATE_CHANGE,
  payload: { langId, id, initId },
})

const toggleSaveLanguageFromTags = (val) => ({
  type: SAVE_LANGUAGE_FROM_TAGS_TOGGLE,
  payload: { val },
})

export default {
  // to props
  getLanguages,
  getLanguagesCancel,
  updateLanguages,
  updateLanguagesCancel,
  changeDefaultLanguage,
  toggleLanguage,
  changeAssociate,
  toggleSaveLanguageFromTags,
  fetchTagsAndSegments,
  fetchTagsAndSegmentsCancel,
  setTagsAndSegmentsPage,
  setTagsAndSegmentsSearch,
}
